module.exports = __webpack_public_path__ + "static/icons/icon-insurance-a372df9403bf011edb76b62bdba4048b.svg";